<template>
    <div class="center-flex" style="min-height:300px" v-if="loading">
        <a-spin tip="Carregando..." size="large"/>
    </div>
    <div v-else>
        <div class="center-flex" style="width:100%; background-color:#000">
            <span style="background-color:#FFF; font-weight:bold; padding:0 20px">Exercício {{ exercicio }}</span>
        </div>

        <div style="margin: 15px 15px 30px">
            <a-descriptions bordered :column="2" size="small">
                <a-descriptions-item label="Testada do Cálculo">{{ infos.testada }}</a-descriptions-item>
                <a-descriptions-item label="Área do Lote para Cálculo">{{ formatarBRL(infos.areaLote) }}</a-descriptions-item>
                <a-descriptions-item label="Fração de Cálculo">{{ infos.fracao }}</a-descriptions-item>
                <a-descriptions-item label="Área Edificada">{{ formatarBRL(infos.areaEdificada) }}</a-descriptions-item>
                <a-descriptions-item label="Valor m² Terreno">{{ formatarBRL(infos.valorM2) }}</a-descriptions-item>
                <a-descriptions-item label="Valor Venal Terreno">{{ formatarBRL(infos.valorVenalTerreno) }}</a-descriptions-item>
                <a-descriptions-item label="Aliquota">{{ formatarBRL(infos.aliquota) }}</a-descriptions-item>
                <a-descriptions-item label="Valor Venal Edific.">{{ formatarBRL(infos.valorVenalEdific) }}</a-descriptions-item>
                <a-descriptions-item label="Valor da Isenção">{{ formatarBRL(infos.valorIsencao) }}</a-descriptions-item>
                <a-descriptions-item label="Valor Venal">{{ formatarBRL(parseFloat(infos.valorVenalTerreno) + parseFloat(infos.valorVenalEdific)) }}</a-descriptions-item>
            </a-descriptions>
        </div>

        <a-table
            :columns="columnsValorVenal"
            :data-source="tableValorVenal"
            bordered
            size="small"
            :pagination="false"
        >
            <template #summary>
                <a-table-summary>
                    <a-table-summary-row>
                        <a-table-summary-cell index="0">Total</a-table-summary-cell>
                        <a-table-summary-cell index="1">{{ formatarBRL(totalCalculado) }}</a-table-summary-cell>
                        <a-table-summary-cell index="2">{{ formatarBRL(totalDepreciado) }}</a-table-summary-cell>
                        <a-table-summary-cell index="3">{{ formatarBRL(totalTributacao) }}</a-table-summary-cell>
                        <a-table-summary-cell index="3">{{ formatarBRL(totalAnterior) }}</a-table-summary-cell>
                        <a-table-summary-cell :index="6">
                            <span v-if="totalPorcentagem > 0" style="color:green">+{{ formatarBRL(totalPorcentagem) }}%</span>
                            <span v-else-if="totalPorcentagem < 0" style="color:red">{{ formatarBRL(totalPorcentagem) }}%</span>
                            <span v-else-if="totalPorcentagem === Infinity" style="color:green">+100%</span>
                            <span v-else>{{ formatarBRL(totalPorcentagem) }}%</span>
                        </a-table-summary-cell>
                    </a-table-summary-row>
                </a-table-summary>
            </template>
        </a-table>

        <a-table
            :columns="columnsTributos"
            :data-source="tableTributos"
            bordered
            size="small"
            :pagination="false"
        >
            <template #summary>
                <a-table-summary>
                    <a-table-summary-row>
                        <a-table-summary-cell :index="0" :col-span="4" style="text-align:right;">Total
                        </a-table-summary-cell>
                        <a-table-summary-cell :index="4">{{ formatarBRL(totalValorTributo) }}</a-table-summary-cell>
                        <a-table-summary-cell :index="5">{{ formatarBRL(totalIsencao) }}</a-table-summary-cell>
                        <a-table-summary-cell :index="6">{{ formatarBRL(totalSaldo) }}</a-table-summary-cell>
                        <a-table-summary-cell :index="6">{{ formatarBRL(totalAnteriorTributos) }}</a-table-summary-cell>
                        <a-table-summary-cell :index="6">
                            <span v-if="totalPorcentagemTributos > 0" style="color:green">+{{ formatarBRL(totalPorcentagemTributos) }}%</span>
                            <span v-else-if="totalPorcentagemTributos < 0" style="color:red">{{ formatarBRL(totalPorcentagemTributos) }}%</span>
                            <span v-else-if="totalPorcentagemTributos === Infinity" style="color:green">+100%</span>
                            <span v-else>{{ formatarBRL(totalPorcentagemTributos) }}%</span>
                        </a-table-summary-cell>
                    </a-table-summary-row>
                </a-table-summary>
            </template>
        </a-table>

        <div v-if="tableEdificacoes.length" style="margin-top: 20px">
            <div class="center-flex" style="width:100%; background-color:#000; line-height: 1px; margin: 30px 0 20px">
                <span style="background-color:#FFF; font-weight:bold; padding:0 20px">Cálculos para cada edificação</span>
            </div>
            <a-table
                :columns="columnsEdificacoes"
                :data-source="tableEdificacoes"
                bordered
                size="small"
                :pagination="false" />
        </div>
    </div>
</template>

<script setup>
import {h, computed, onMounted, ref} from "vue";
import axios from "axios";

const props = defineProps(['propertyId']);
const loading = ref(true);
const infos = ref(null);
const tableValorVenal = ref([]);
const tableTributos = ref([]);
const tableEdificacoes = ref([]);
const exercicio = ref(0)
const columnsValorVenal = computed(() => [
    {title: 'Valor Venal', dataIndex: 'descricao'},
    {title: 'Valor Calculado', dataIndex: 'valorCalculado', customRender: ({value}) => formatarBRL(value),},
    {title: 'Valor Depreciado', dataIndex: 'valorDepreciado', customRender: ({value}) => formatarBRL(value),},
    {title: 'Valor para Tributação', dataIndex: 'valorTributacao', customRender: ({value}) => formatarBRL(value),},
    {title: exercicio.value - 1, dataIndex: 'valorAnterior', customRender: ({value}) => formatarBRL(value),},
    {title: '%', dataIndex: 'porcentagem',
        customRender: ({value}) => {
            if (value === Infinity) return h('span', {style: {color: 'green'}}, `+100%`)

            if (value > 0) return h('span', {style: {color: 'green'}}, `+${formatarBRL(value)}%`)
            else if (value < 0) return h('span', {style: {color: 'red'}}, `-${formatarBRL(value)}%`)
            else return h('span', `0,00%`)
        }
    },
]);
const columnsTributos = computed(() => [
    {title: 'Receita', dataIndex: 'receita'},
    {title: 'Descrição', dataIndex: 'desc1'},
    {title: 'Histórico', dataIndex: 'historico'},
    {title: 'Descrição', dataIndex: 'desc2'},
    {title: 'Valor Calculado', dataIndex: 'valor', customRender: ({value}) => formatarBRL(value)},
    {title: 'Valor Isenção', dataIndex: 'isencao', customRender: ({value}) => (value > 0 ? `${formatarBRL(value)}` : '0,00')},
    {title: 'Saldo a Pagar', customRender: ({record}) => formatarBRL(record.valor - record.isencao),},
    {title: exercicio.value - 1, dataIndex: 'valorAnterior', customRender: ({value}) => formatarBRL(value)},
    {title: '%',
        customRender: ({record}) => {
            if (record.valorAnterior === Infinity) return h('span', {style: {color: 'green'}}, `+100%`)
            let porcentagem = (((record.valor - record.isencao) - record.valorAnterior) / record.valorAnterior) * 100

            if (porcentagem > 0) return h('span', {style: {color: 'green'}}, `+${formatarBRL(porcentagem)}%`)
            else if (porcentagem < 0) return h('span', {style: {color: 'red'}}, `${formatarBRL(porcentagem)}%`)
            else return h('span', `0,00%`)
        }
    },
]);
const columnsEdificacoes = [
    {title: 'Nº', dataIndex: 'id'},
    {title: 'Área', dataIndex: 'area', customRender: ({value}) => formatarBRL(value)},
    {title: 'Exercício', dataIndex: 'exercicio'},
    {title: 'Valor m²', dataIndex: 'valor_m2', customRender: ({value}) => formatarBRL(value)},
    {title: 'Pontuação', dataIndex: 'pontuacao'},
    {title: 'Valor Venal', dataIndex: 'valorVenal', customRender: ({value}) => (value > 0 ? `${formatarBRL(value)}` : '0,00')},
];


onMounted(async () => {
    const response = (await window.axios.get(`/api/map-actions/bic/assessed-value/${props.propertyId}`)).data.data

    exercicio.value = response.lote.exercicio
    infos.value = {
        testada: response.lote.testada,
        areaLote: response.lote.area_lote,
        fracao: parseFloat(response.lote.fracao) == 0 ? 100 : response.lote.fracao,
        areaEdificada: response.lote.area_edificada_total,
        valorM2: response.lote.valor_m2_terreno,
        valorVenalTerreno: response.lote.valor_venal_terreno,
        aliquota: response.lote.aliquota,
        valorVenalEdific: response.lote.valor_venal_edificada,
        valorIsencao: response.lote.valor_isencao
    }

    tableValorVenal.value = [
        {
            descricao: 'Terreno',
            valorCalculado: response.lote.valor_venal_terreno,
            valorDepreciado: 0,
            valorTributacao: response.lote.valor_venal_terreno,
            valorAnterior: response.lote.valor_venal_anterior,
            porcentagem: ((response.lote.valor_venal_terreno - response.lote.valor_venal_anterior) / response.lote.valor_venal_anterior) * 100,
        },
        ...response.edificacoes.map((edif) => ({
            descricao: `Edificação ${edif.construcao}`,
            valorCalculado: edif.valor_venal_total,
            valorDepreciado: edif.valor_depreciado,
            valorTributacao: edif.valor_venal,
            valorAnterior: edif.valor_venal_anterior,
            porcentagem: ((edif.valor_venal - edif.valor_venal_anterior) / edif.valor_venal_anterior) * 100
        }))
    ]

    tableEdificacoes.value = [
        ...response.edificacoes.map((edif) => ({
            id: edif.construcao,
            area: edif.area_edificada,
            exercicio: exercicio.value,
            valor_m2: edif.valor_m2,
            pontuacao: edif.pontuacao,
            valorVenal: edif.valor_venal,
        }))
    ]

    tableTributos.value = response.tributos
    loading.value = false
})

const totalCalculado = computed(() => tableValorVenal.value.reduce((acc, i) => acc + parseFloat(i.valorCalculado || 0), 0))
const totalDepreciado = computed(() => tableValorVenal.value.reduce((acc, i) => acc + parseFloat(i.valorDepreciado || 0), 0))
const totalTributacao = computed(() => tableValorVenal.value.reduce((acc, i) => acc + parseFloat(i.valorTributacao || 0), 0))
const totalAnterior = computed(() => tableValorVenal.value.reduce((acc, i) => acc + parseFloat(i.valorAnterior || 0), 0))
const totalPorcentagem = computed(() => ((totalTributacao.value - totalAnterior.value) / totalAnterior.value) * 100)

const totalValorTributo = computed(() => tableTributos.value.reduce((a, t) => a + +t.valor, 0))
const totalIsencao = computed(() => tableTributos.value.reduce((a, t) => a + +t.isencao, 0))
const totalSaldo = computed(() => totalValorTributo.value - totalIsencao.value)
const totalAnteriorTributos = computed(() => tableTributos.value.reduce((acc, i) => acc + parseFloat(i.valorAnterior || 0), 0))
const totalPorcentagemTributos = computed(() => ((totalSaldo.value - totalAnteriorTributos.value) / totalAnteriorTributos.value) * 100)

const formatarBRL = (valor) => new Intl.NumberFormat('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(valor)
</script>

<style scoped>
.center-flex {
    display: flex;
    justify-content: center;
    align-items: center;
}

::v-deep(.ant-table) {
    margin: 0 15px 30px;
    border: solid 1px #d9d9d910 !important;
    border-radius: 10px !important;
    overflow: hidden !important;
}

::v-deep(.ant-table-summary) {
    border-top: none !important;
}

::v-deep(.ant-table-summary .ant-table-cell) {
    border-top: 1px solid #d9d9d9 !important;
    font-weight: bold !important;
    padding: 8px 10px !important;
}

::v-deep(.ant-table-thead .ant-table-cell) {
    text-align: center !important;
    padding: 8px 10px !important;
}

::v-deep(.ant-table-tbody),
::v-deep(.ant-table-summary) {
    text-align: end !important;
}

::v-deep(.ant-descriptions-item-label) {
    text-align: end !important;
}
</style>